export const EmojiList = [
  { id: 1, emoji: "laugh", emojiType: "LAUGH" },
  { id: 2, emoji: "love", emojiType: "LOVE" },
  { id: 3, emoji: "shock", emojiType: "SHOCK" },
  { id: 4, emoji: "cry", emojiType: "CRY" },
  { id: 5, emoji: "happy", emojiType: "HAPPY" }
];
